export default {
    page_title: "Kevi | Informe de Email Marketing",
    title: "Informe de Email Marketing",
    stats: {
        total_sent: "Emails Enviados",
        delivered: "Entregados",
        opened: "Abiertos",
        clicked: "Clics",
        failed: "Fallidos",
        total_orders: "Pedidos Convertidos",
        total_reactivated_orders: "Pedidos Reactivados",
        total_revenue: "Facturación Incentivada",
    },
    chart: {
        sent: "Enviados",
        delivered: "Entregados",
        opened: "Abiertos",
        clicked: "Clics",
    },
    table: {
        title: "Rendimiento por Automatización",
        automation: "Automatización",
        sent: "Enviados",
        delivered: "Entregados",
        opened: "Abiertos",
        clicked: "Clics",
        replies: "Respuestas",
        open_rate: "Tasa de Apertura",
        click_rate: "Tasa de Clics",
        orders_count: "Pedidos Convertidos",
        reactivated_orders_count: "Pedidos Reactivados",
        revenue: "Facturación Incentivada",
        export_csv: "Exportar CSV",
        exporting: "Exportando...",
        export_filename: "informe-email-automatizaciones",
    },
    filters: {
        status_label: "Estado",
        automation_label: "Automatización",
        status_accepted: "Aceptada",
        status_scheduled: "Programada",
        status_sent: "Enviada",
        status_failed: "Fallida",
    },
    empty: {
        no_emails_message: "No has enviado ningún email en este período",
        create_automation: "Crear Automatización",
        no_tracking_message: "Habla con nuestro soporte para activar el seguimiento de clics y aperturas en tu remitente de email",
        no_data_period: "No hay suficientes datos para el período seleccionado",
    },
};
